
import { useQuery } from "@tanstack/react-query"
import { supabase } from "@/integrations/supabase/client"
import { useAuth } from "./useAuth"

export const useUnitsForIncidents = () => {
  const { profile } = useAuth()
  
  return useQuery({
    queryKey: ["units-for-incidents", profile?.condominium_id],
    queryFn: async () => {
      if (!profile?.condominium_id) return []

      const { data, error } = await supabase
        .from("units")
        .select(`
          id,
          number,
          building,
          unit_details:unit_details(owner_name)
        `)
        .eq("condominium_id", profile.condominium_id)
        .order("number")

      if (error) throw error
      return data
    },
    enabled: !!profile?.condominium_id
  })
}
